// Mobile Zoom Override - Simple and Direct
(function() {
  'use strict';

  // Only run on mobile
  const isMobile = window.innerWidth <= 749 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  if (!isMobile) return;

  console.log('Mobile zoom override loaded');

  // Wait for DOM and theme to be ready
  function initMobileZoom() {
    // Hide original PhotoSwipe modal
    const originalPswp = document.querySelector('.pswp:not(.pswp--mobile-optimized)');
    if (originalPswp) {
      originalPswp.style.display = 'none';
      console.log('Hidden original PhotoSwipe');
    }

    // Override zoom button clicks
    document.addEventListener('click', function(e) {
      const zoomButton = e.target.closest('[data-action="open-product-zoom"]');
      const zoomImage = e.target.closest('[data-zoom-image]');
      
      if (zoomButton || zoomImage) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Zoom click intercepted');
        
        openMobileZoom();
        return false;
      }
    }, true); // Use capture phase

    console.log('Mobile zoom handlers attached');
  }

  function openMobileZoom() {
    console.log('Opening mobile zoom');
    
    // Get all product images
    const productImages = document.querySelectorAll('[data-zoom-image]');
    console.log('Found images:', productImages.length);
    
    // DEBUG: Log each image and its src
    productImages.forEach((img, index) => {
      console.log(`Image ${index}:`, {
        element: img,
        src: img.src,
        currentSrc: img.currentSrc,
        tagName: img.tagName,
        attributes: {
          'data-src': img.getAttribute('data-src'),
          'data-original-src': img.getAttribute('data-original-src'),
          'data-image-src': img.getAttribute('data-image-src'),
          'data-image-width': img.getAttribute('data-image-width'),
          'data-image-height': img.getAttribute('data-image-height'),
          'data-widths': img.getAttribute('data-widths')
        }
      });
    });
    
    if (productImages.length === 0) return;

    // Create simple fullscreen modal
    const modal = createMobileModal(productImages);
    document.body.appendChild(modal);
    
    // Show modal
    setTimeout(() => {
      modal.classList.add('mobile-zoom--open');
      document.body.style.overflow = 'hidden';
    }, 10);
  }

  function createMobileModal(images) {
    const modal = document.createElement('div');
    modal.className = 'mobile-zoom-modal';
    
    let currentIndex = 0;
    const imageArray = Array.from(images);
    
    // Get product title
    const productTitle = document.querySelector('.ProductMeta__Title')?.textContent || 
                        document.querySelector('h1')?.textContent || 
                        'Product Images';
    
    modal.innerHTML = `
      <div class="mobile-zoom__header">
        <div class="mobile-zoom__title">${productTitle}</div>
        <div class="mobile-zoom__counter">${currentIndex + 1} / ${imageArray.length}</div>
        <button class="mobile-zoom__close" type="button">&times;</button>
      </div>
      
      <div class="mobile-zoom__main">
        <div class="mobile-zoom__image-container">
          <img class="mobile-zoom__image" src="${(() => {
            const mainSrc = imageArray[currentIndex].getAttribute('data-image-src') || '';
            console.log('Main image src:', mainSrc);
            return mainSrc;
          })()}" alt="">
        </div> 
      </div>
      
      <div class="mobile-zoom__footer">
        <div class="mobile-zoom__controls">
          <button class="mobile-zoom__prev" type="button">‹</button>
          <button class="mobile-zoom__next" type="button">›</button>
        </div>
        
        <div class="mobile-zoom__thumbs">
          ${imageArray.map((img, index) => {
            const imgSrc = img.getAttribute('data-image-src') || '';
            console.log(`Thumbnail ${index} src:`, imgSrc);
            return `
            <div class="mobile-zoom__thumb ${index === currentIndex ? 'active' : ''}" data-index="${index}">
              <img src="${imgSrc}" alt="">
            </div>
          `;
          }).join('')}
        </div> 
      </div>
    `;

    // Add event listeners
    const closeBtn = modal.querySelector('.mobile-zoom__close');
    const prevBtn = modal.querySelector('.mobile-zoom__prev');
    const nextBtn = modal.querySelector('.mobile-zoom__next'); 
    const mainImage = modal.querySelector('.mobile-zoom__image');
    const counter = modal.querySelector('.mobile-zoom__counter');
    const thumbs = modal.querySelectorAll('.mobile-zoom__thumb');

    function updateImage() {
      const img = imageArray[currentIndex];
      const newSrc = img.getAttribute('data-image-src') || '';
      console.log('Update image src:', newSrc);
      mainImage.src = newSrc;
      counter.textContent = `${currentIndex + 1} / ${imageArray.length}`;
      
      thumbs.forEach((thumb, index) => {
        thumb.classList.toggle('active', index === currentIndex);
      });
    }

    closeBtn.addEventListener('click', () => {
      modal.classList.remove('mobile-zoom--open');
      document.body.style.overflow = '';
      setTimeout(() => modal.remove(), 300);
    });

    prevBtn.addEventListener('click', () => {
      currentIndex = currentIndex > 0 ? currentIndex - 1 : imageArray.length - 1;
      updateImage();
    });

    nextBtn.addEventListener('click', () => {
      currentIndex = currentIndex < imageArray.length - 1 ? currentIndex + 1 : 0;
      updateImage();
    });

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        currentIndex = index;
        updateImage();
      });
    });

    // Add swipe support
    let startX = null;
    const imageContainer = modal.querySelector('.mobile-zoom__image-container');
    
    imageContainer.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    });

    imageContainer.addEventListener('touchend', (e) => {
      if (startX === null) return;
      
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
       
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          // Swipe left - next image
          currentIndex = currentIndex < imageArray.length - 1 ? currentIndex + 1 : 0;
        } else {
          // Swipe right - previous image
          currentIndex = currentIndex > 0 ? currentIndex - 1 : imageArray.length - 1;
        }
        updateImage();
      }
      
      startX = null;
    });

    return modal;
  }

  // Add CSS styles
  const style = document.createElement('style');
  style.textContent = `
    .mobile-zoom-modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      background: rgba(255, 255, 255, 0.98);
      z-index: 9999;
      display: flex;
      flex-direction: column;
      opacity: 0;
      transition: opacity 0.3s ease;
      font-family: var(--FONT-STACK-BODY, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif);
    }

    .mobile-zoom-modal.mobile-zoom--open {
      opacity: 1;
    }

    .mobile-zoom__header {
      flex: 0 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 15px;
      background: rgba(255, 255, 255, 0.95);
      color: var(--COLOR-TEXT, #000);
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(10px);
    }

    .mobile-zoom__title {
      font-family: var(--FONT-STACK-HEADING, inherit);
      font-weight: var(--FONT-WEIGHT-HEADING, 600);
      font-size: 14px;
      color: var(--COLOR-TEXT, #000);
      flex: 1;
      margin-right: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .mobile-zoom__counter {
      font-size: 14px;
      font-weight: 500;
      color: var(--COLOR-TEXT-LIGHT, #666);
      margin-right: 10px;
    }

    .mobile-zoom__close {
      background: none;
      border: none;
      color: var(--COLOR-TEXT, #000);
      font-size: 24px;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 50%;
      transition: background-color 0.2s ease;
    }

    .mobile-zoom__close:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }

    .mobile-zoom__main {
      /*flex: 1 1 auto;*/
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px;
      min-height: 0;
      background: #fff;
    }

    .mobile-zoom__image-container {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
    }

    .mobile-zoom__image {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    }

    .mobile-zoom__footer {
      flex: 0 0 auto;
      background: rgba(255, 255, 255, 0.95);
      padding: 10px 15px 15px;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(10px);
    }

    .mobile-zoom__controls {
      display: flex;
      justify-content: center;
      gap: 20px;
      margin-bottom: 10px;
    }

    .mobile-zoom__prev,
    .mobile-zoom__next {
      background: var(--COLOR-BG, #fff);
      border: 1px solid rgba(0, 0, 0, 0.2);
      color: var(--COLOR-TEXT, #000);
      width: 44px;
      height: 44px;
      border-radius: 50%;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .mobile-zoom__prev:hover,
    .mobile-zoom__next:hover {
      background: var(--COLOR-ACCENT, #000);
      color: #fff;
      transform: scale(1.05);
    }

    .mobile-zoom__thumbs {
      display: flex;
      gap: 8px;
      overflow-x: auto;
      padding: 5px 0;
      -webkit-overflow-scrolling: touch;
    }

    .mobile-zoom__thumb {
      flex: 0 0 50px;
      width: 50px;
      height: 50px;
      border-radius: 6px;
      overflow: hidden;
      border: 2px solid rgba(0, 0, 0, 0.1);
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .mobile-zoom__thumb.active {
      border-color: var(--COLOR-ACCENT, #000);
      transform: scale(1.05);
    }

    .mobile-zoom__thumb:hover {
      transform: scale(1.02);
    }

    .mobile-zoom__thumb img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .mobile-zoom__thumbs::-webkit-scrollbar {
      display: none;
    }
  `;
  document.head.appendChild(style);

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileZoom);
  } else {
    initMobileZoom();
  }

})();
